import { render, staticRenderFns } from "./ResponsiblesModal.vue?vue&type=template&id=00f32c04&scoped=true&"
import script from "./ResponsiblesModal.vue?vue&type=script&lang=js&"
export * from "./ResponsiblesModal.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiblesModal.vue?vue&type=style&index=0&id=00f32c04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f32c04",
  null
  
)

export default component.exports